module.exports = __webpack_public_path__ + "img/working.01e1a9a4.gif";